import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import noDataImage from '../../../../assets/images/projections-no-data.svg';
import Loader from '../../../../components/Loader';

const NoData: React.FC<{
  handleRefresh: () => void;
  isLoading: boolean;
  isError: boolean;
}> = ({ handleRefresh, isLoading, isError }) => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '538px',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '0.5rem',
      }}
    >
      {isLoading && !isError ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '440px',
          }}
        >
          <Loader />
        </Box>
      ) : (
        <>
          <img src={noDataImage} alt="No data" style={{ paddingLeft: '0.75rem' }} />
          <Typography
            sx={{
              fontSize: '0.875rem',
              lineHeight: '1.25rem',
              fontWeight: 500,
              color: '#6C6C6C',
            }}
          >
            No data available
          </Typography>
          <Button
            style={{
              textTransform: 'none',
              backgroundColor: '#FFFFFF',
              color: '#51B8B0',
              borderRadius: '0.5rem',
              padding: '0.5rem 1rem',
              border: 'none',
              fontSize: '0.875rem',
              lineHeight: '1.25rem',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
            }}
            onClick={handleRefresh}
          >
            <Refresh />
            Refresh
          </Button>
        </>
      )}
    </Box>
  );
};

export default NoData;
